// Gamifikacijos skaičiavimai iš aplankytų vietų. Grynas, be šalutinių efektų.

// ⚠️ 2026-09-22: buvo 'jura' (be ū) — bazėje kategorija yra 'jūra', tad
// jūros vietos niekada nebuvo skaičiuojamos ir ženkliukas neuždirbamas.
const KATEGORIJOS_STAT = ['gamta', 'jūra', 'istorija', 'miestas', 'veikla']

const KAT_ZODIS = { gamta: 'gamta', 'jūra': 'jūra', istorija: 'istorija', miestas: 'miestas', veikla: 'veikla' }
const KAT_KILM = { gamta: 'gamtą', 'jūra': 'jūrą', istorija: 'istoriją', miestas: 'miestus', veikla: 'veiklas' }

const DIENOS = ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis']

export function skaiciuotiStatus(aplankytos, visosVietos, prisiminimai) {
  const vietos = aplankytos.length
  const visoVietu = (visosVietos && visosVietos.length) || 149

  const km = Math.round(aplankytos.reduce((s, v) => s + (v.km || 0), 0))
  const tolimiausia = Math.round(aplankytos.reduce((m, v) => Math.max(m, v.km || 0), 0))
  // Prisiminimų skaičius — iš naujo modelio (geo-žymėtos nuotraukos), jei perduota;
  // kitaip senoji logika (aplankytos su nuotrauka).
  const nuotraukos = prisiminimai != null
    ? prisiminimai.length
    : aplankytos.filter(v => v.turiNuotrauka).length
  const regionai = new Set(aplankytos.map(v => v.regionas).filter(Boolean)).size

  // Daugiausia per vieną dieną
  const perDiena = {}
  aplankytos.forEach(v => {
    const d = new Date(v.data).toDateString()
    perDiena[d] = (perDiena[d] || 0) + 1
  })
  const daugiausiaPerDiena = Object.values(perDiena).reduce((m, n) => Math.max(m, n), 0)

  // Pagal kategoriją (be „vaikams")
  const pagalKategorija = {}
  KATEGORIJOS_STAT.forEach(k => {
    pagalKategorija[k] = {
      aplankyta: aplankytos.filter(v => v.kategorija === k).length,
      viso: (visosVietos || []).filter(v => v.kategorija === k).length,
    }
  })

  // Mėgstamiausia kategorija
  let megstama = null, maxK = 0
  KATEGORIJOS_STAT.forEach(k => {
    if (pagalKategorija[k].aplankyta > maxK) { maxK = pagalKategorija[k].aplankyta; megstama = k }
  })
  const megstamaProc = vietos > 0 && megstama ? Math.round((maxK / vietos) * 100) : 0

  // Vidutinis ruožas
  const suKm = aplankytos.filter(v => v.km)
  const vidutinisKm = suKm.length ? Math.round(suKm.reduce((s, v) => s + v.km, 0) / suKm.length) : 0

  // Dažniausia diena
  const dienuSk = {}
  aplankytos.forEach(v => { const d = new Date(v.data).getDay(); dienuSk[d] = (dienuSk[d] || 0) + 1 })
  let dazniausiaDiena = null, maxD = 0
  Object.entries(dienuSk).forEach(([d, n]) => { if (n > maxD) { maxD = n; dazniausiaDiena = DIENOS[Number(d)] } })

  const procIstirta = Math.round((vietos / visoVietu) * 100)

  return {
    vietos, visoVietu, km, tolimiausia, nuotraukos, regionai, daugiausiaPerDiena,
    pagalKategorija, megstama, megstamaProc, vidutinisKm, dazniausiaDiena, procIstirta,
  }
}

// ── Ženkliukai (LAIKINOS ikonos — tikri dizainai vėliau) ──
export const ZENKLIUKAI = [
  { id: 'pirma', pavadinimas: 'Pirma kelionė', ikona: 'flag', tikslas: 1, dabartinis: s => s.vietos },
  { id: 'penkios', pavadinimas: '5 vietos', ikona: 'map-pin', tikslas: 5, dabartinis: s => s.vietos },
  { id: 'dvidesimt', pavadinimas: '25 vietos', ikona: 'map-pin', tikslas: 25, dabartinis: s => s.vietos },
  { id: 'gamta', pavadinimas: 'Gamtos ieškotojas', ikona: 'leaf', tikslas: 5, dabartinis: s => (s.pagalKategorija.gamta || {}).aplankyta || 0 },
  { id: 'pilys', pavadinimas: 'Pilių tyrinėtojas', ikona: 'tower', tikslas: 3, dabartinis: s => (s.pagalKategorija.istorija || {}).aplankyta || 0 },
  { id: 'jura', pavadinimas: 'Baltijos vaikas', ikona: 'anchor', tikslas: 1, dabartinis: s => (s.pagalKategorija['jūra'] || {}).aplankyta || 0 },
  { id: 'prisiminimai', pavadinimas: '10 prisiminimų', ikona: 'photo', tikslas: 10, dabartinis: s => s.nuotraukos },
  { id: 'regionai', pavadinimas: '5 regionai', ikona: 'map-2', tikslas: 5, dabartinis: s => s.regionai },
  { id: 'simtas', pavadinimas: '100 vietų', ikona: 'pin', tikslas: 100, dabartinis: s => s.vietos },
  { id: 'visos', pavadinimas: 'Visa Lietuva', ikona: 'star', tikslas: 149, dabartinis: s => s.visoVietu ? Math.min(s.vietos, s.visoVietu) : s.vietos },
]

export function getZenkliukai(statai) {
  return ZENKLIUKAI.map(z => {
    const esamas = Math.max(0, z.dabartinis(statai) || 0)
    return { id: z.id, pavadinimas: z.pavadinimas, ikona: z.ikona, tikslas: z.tikslas, esamas: Math.min(esamas, z.tikslas), uzdirbtas: esamas >= z.tikslas }
  })
}

// ── Taškai / lygiai ──
const SLENKSCIAI = [0, 60, 150, 300, 500, 800, 1200, 1700, 2300, 3000]

export function skaiciuotiTaskus(statai, uzdirbtaZenkliuku) {
  return statai.vietos * 10 + statai.nuotraukos * 5 + (uzdirbtaZenkliuku || 0) * 25
}

export function skaiciuotiLygi(t) {
  let lyg = 1
  for (let i = 0; i < SLENKSCIAI.length; i++) { if (t >= SLENKSCIAI[i]) lyg = i + 1 }
  const pradzia = SLENKSCIAI[lyg - 1] || 0
  const kitas = SLENKSCIAI[lyg]
  const iki = kitas != null ? kitas - t : 0
  const proc = kitas != null ? Math.round(((t - pradzia) / (kitas - pradzia)) * 100) : 100
  return { lygis: lyg, taskai: t, iki, kitas, proc }
}

// ── „Apie tave" archetipas ──
export function archetipas(statai) {
  if (statai.vietos < 3) return null // per mažai duomenų
  const kat = statai.megstama
  if (statai.vidutinisKm >= 120) {
    return {
      tipas: 'Tolimų ruožų klajūnas',
      ikona: 'compass',
      aprasymas: `Keliauji rečiau, bet kai išvažiuoji — nuvažiuoji toli. Vidutiniškai ${statai.vidutinisKm} km${kat ? `, o labiausiai trauki ${KAT_KILM[kat]}` : ''}.`,
    }
  }
  if (statai.megstamaProc >= 50 && kat) {
    return {
      tipas: kat === 'gamta' ? 'Gamtos ieškotojas' : kat === 'jūra' ? 'Baltijos siela' : kat === 'istorija' ? 'Istorijos medžiotojas' : kat === 'veikla' ? 'Nuotykių ieškotojas' : 'Miestų tyrinėtojas',
      ikona: kat === 'gamta' ? 'leaf' : kat === 'jūra' ? 'anchor' : kat === 'istorija' ? 'tower' : kat === 'veikla' ? 'compass' : 'building',
      aprasymas: `${statai.megstamaProc}% tavo kelionių — ${KAT_ZODIS[kat]}. Aišku, kas tave traukia.`,
    }
  }
  return {
    tipas: 'Smalsus keliautojas',
    ikona: 'route',
    aprasymas: `Aplankei ${statai.vietos} vietų įvairiose kategorijose — tave domina viskas po truputį.`,
  }
}
